export var tradingConfig;

/**
 * Trading配置
 * 1.初始化了一些静态引用
 */
export var TradingConfig = {
  inited: false,
  init: function init(config) {
    tradingConfig = config;
    TradingConfig.inited = true;
  }
};